<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_1"></a><a id="page_2"></a>Cast of Characters</h2>
<p class="noindentt"><span class="bold">Patrick Abbott.</span> A tall, lanky private detective from San Francisco, about to become a U.S. Marine.</p>
<p class="noindentt"><span class="bold">Jean Abbott.</span> His brand-new wife, who wants to make the most of what time they have together before Pat reports for duty.</p>
<p class="noindentt"><span class="bold">Ellen Bland.</span> A calm, collected woman whom Pat knew in Paris and who brings out the protective instinct in most men. Jean distrusts her.</p>
<p class="noindentt"><span class="bold">Louis Bland.</span> Her nasty, controlling ex-husband who still exerts a powerful hold over Ellen and their children.</p>
<p class="noindentt"><span class="bold">Dick Bland.</span> Their 16-year-old son, already on the road to being an alcoholic.</p>
<p class="noindentt"><span class="bold">Susan Bland.</span> Their 18-year-old daughter, outspoken and youthfully self-absorbed.</p>
<p class="noindentt"><span class="bold">Anna Forbes.</span> Louis’s former nursemaid, now the family housekeeper, a rude, sour-faced woman who despises Ellen but still adores Louis.</p>
<p class="noindentt"><span class="bold">Hank Rawlings.</span> A chemical engineer who’s deeply in love with Ellen.</p>
<p class="noindentt"><span class="bold">Mary Kent.</span> An expatriate who fled occupied France. Ruthless and overbearing, she’s considered a good match for Louis, who is expected to marry her.</p>
<p class="noindentt"><span class="bold">Daphne Garnett.</span> Another of the Blands’ Parisian friends now living in New York. A seemingly silly woman, she’s more perceptive than people expect.</p>
<p class="noindentt"><span class="bold">Clint Moran.</span> Another refugee, indolent and enigmatic and an inventive pianist. Flat broke, he lives in a flophouse. He and Louis go back a long way.</p>
<p class="noindentt"><span class="bold">Bill Reynolds.</span> Susan’s fiancé, who’s serving in the Merchant Marines.</p>
<p class="noindentt"><span class="bold">Dr. Maxton Seward.</span> The family physician, fat and sleek and opportunistic.</p>
<p class="noindentt"><span class="bold">Patrolman Isaac Goldberg.</span> Conscientious to a fault, he will never believe that Pat and Jean are really married.</p>
<p class="noindentt"><span class="bold">Lieutenant Jeffry Dorn.</span> A deceptively angelic-looking police detective.</p>
<p class="noindentt"><span class="bold">Laura Gilbert.</span> Hank’s beautiful, dedicated secretary, in love with her boss.</p>
<p class="noindentt"><span class="bold">Sarah Howe.</span> The fussy old maid who lives across the hall from Laura.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fm01.vue?204d4bb6